import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { sellerImages } from '../../data/marketVisual';
import type { MarketSeller } from '../../types/market';

/**
 * A provider as a storefront rather than a table row. Identity, what they do,
 * whether Campuzon checked them, and how reliably they reply — four separate
 * signals, never merged into one score.
 */
export function ProviderCard({
  seller
}: {
  seller: MarketSeller;
}) {
  const image = sellerImages[seller.id];
  return <Link to={`/market/provider/${seller.id}`} className="group flex h-full w-full flex-col rounded-card border border-line bg-surface p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-[border-color,box-shadow] duration-150 ease-out hover:border-line-strong hover:shadow-[0_6px_18px_rgba(15,23,42,0.07)]" data-id="element-2923" data-mp="1di6b6mtf0yne">
      <div className="flex items-start gap-3" data-id="element-2924" data-mp="ypch9wdecfz7">
        <span className="h-14 w-14 shrink-0 overflow-hidden rounded-full bg-canvas" data-id="element-2925" data-mp="trkrp90855y6">
          {image ? <img src={image} alt="" loading="lazy" className="h-full w-full object-cover" data-id="element-2926" data-mp="2239sb2p8xtcb" /> : <span className="flex h-full w-full items-center justify-center text-h4 font-semibold text-ink-subtle" data-id="element-2927" data-mp="271l2jejge5v2">
              {seller.displayName.charAt(0)}
            </span>}
        </span>
        <div className="min-w-0" data-id="element-2928" data-mp="2gsfrwrrzxlkq">
          <p className="truncate text-body font-semibold text-ink" data-id="element-2929" data-mp="1j56z0bpo1a8p">{seller.displayName}</p>
          <p className="mt-0.5 truncate text-caption text-ink-muted" data-id="element-2930" data-mp="1j7jqpgl86yyy">{seller.kind}</p>
          <span className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-ok-50 px-2 py-0.5 text-caption font-medium text-ok-800" data-id="element-2931" data-mp="1o6e6sart69fd">
            <BadgeCheckIcon aria-hidden className="h-3.5 w-3.5" data-id="element-2932" data-mp="1x5hqngysusux" />
            Verified
          </span>
        </div>
      </div>

      <div className="mt-3.5 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-line pt-3" data-id="element-2933" data-mp="34hrw1d8gv3g6">
        {seller.rating !== undefined && <span className="cz-num inline-flex items-center gap-1 text-caption text-ink" data-id="element-2934" data-mp="38lzkraexcjee">
            <StarIcon aria-hidden className="h-3.5 w-3.5 fill-warn-700 text-warn-700" data-id="element-2935" data-mp="19hhn2ststlr0" />
            {seller.rating.toFixed(1)}
            <span className="text-ink-subtle" data-id="element-2936" data-mp="1iftdatqr6hix">({seller.reviewCount})</span>
          </span>}
        {seller.responseRateLabel && <span className="cz-num text-caption text-ink-subtle" data-id="element-2937" data-mp="1di9x3oahvuoc">{seller.responseRateLabel}</span>}
      </div>
    </Link>;
}